export const SET_ACTIVE_DATE = 'view/SET_ACTIVE_DATE'
export const SET_SHOW_DATE_SELECT = 'view/SET_SHOW_DATE_SELECT'
export const SET_SHOW_FILTERS = 'view/SET_SHOW_FILTERS'
export const SET_SELECTED_CATEGORY_ID = 'view/SET_SELECTED_CATEGORY_ID'
export const SET_MIN_AMOUNT = 'view/SET_MIN_AMOUNT'
export const SET_MAX_AMOUNT = 'view/SET_MAX_AMOUNT'
